import { z } from "zod";
import { User } from "./schemas.js";
/**
 * Wire contract for errors. Every non-2xx JSON response from the API has this
 * shape so the web api-client can narrow on `code` instead of status alone.
 */
export const ApiErrorCode = z.enum([
    "bad_request",
    "unauthorized",
    "forbidden",
    "not_found",
    "conflict",
    "validation_failed",
    "rate_limited",
    "internal",
]);
export const ApiErrorBody = z.object({
    error: z.object({
        code: ApiErrorCode,
        message: z.string(),
        /** Field-level issues, present when code === "validation_failed". */
        issues: z
            .array(z.object({ path: z.string(), message: z.string() }))
            .optional(),
    }),
});
export const HTTP_STATUS_BY_ERROR_CODE = {
    bad_request: 400,
    unauthorized: 401,
    forbidden: 403,
    not_found: 404,
    conflict: 409,
    validation_failed: 422,
    rate_limited: 429,
    internal: 500,
};
export const HealthResponse = z.object({
    ok: z.literal(true),
    service: z.string(),
    time: z.number().int(),
});
/** GET /api/auth/me and POST /api/auth/login both return this. */
export const SessionResponse = z.object({
    user: User,
});
//# sourceMappingURL=api.js.map